import { Box, Skeleton, Typography } from '@mui/material';
import { SelectAdSettings, SelectCallToActions, SelectConversionDomain } from './FacebookFormComponents';
import type { FC } from 'react';
import { Suspense, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { SuspenseErrorFallback, Switch, TextField } from 'components/common';
import { Platform } from '../../../constants';
import { ErrorBoundary } from 'react-error-boundary';

const AdForm: FC = () => {
  const { watch, trigger } = useFormContext();
  const platform = watch('platform') as string;
  const isWebPlatform = String(platform) === String(Platform.WEB);

  useEffect(() => {
    void trigger();
  }, [trigger]);

  return (
    <>
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        Create Ads
      </Typography>
      <Box sx={{ display: 'flex', gap: 4, flexDirection: 'column', width: '100%' }}>
        <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column', width: '50%' }}>
          <SelectCallToActions />
          <TextField name={'adLabelSuffix'} dataTestId={'adLabelSuffix'} inputLabel={'Ad label suffix'}
                     helperText="Optional text at the end of ad label" />
          {isWebPlatform &&
            <ErrorBoundary
              fallback={
                <SuspenseErrorFallback
                  title={'Conversion Domain'}
                  message={'Error occur'}
                />
              }>
              <Suspense
                fallback={
                  <Skeleton
                    height={40}
                    sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
                  />
                }>
                <SelectConversionDomain />
              </Suspense>
            </ErrorBoundary>
          }
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', width: '100%', gap: 2 }}>
            {isWebPlatform && <Switch dataTestId={'hotjarSwitcher'} name={'hotjar'} label={'Hotjar'} />}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column', width: '100%' }}>
          <ErrorBoundary
            fallback={
              <SuspenseErrorFallback
                title={'Ad Settings'}
                message={'Error occur'}
              />
            }>
            <Suspense
              fallback={
                <Skeleton
                  height={40}
                  sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
                />
              }>
              <SelectAdSettings />
            </Suspense>
          </ErrorBoundary>
        </Box>
      </Box>
    </>
  );
};

export default AdForm;